import { Cookies } from "quasar";

export interface UserStateInterface {
  ma_session: string;
  inited: boolean;
  ref: any;
  id: any;
  name: string;
  acl: any;
  menuRef: any;
  access: { [key: string]: boolean };
  logins: any[];
  classesRools: any;
}

function state(): UserStateInterface {
  return {
    ma_session: Cookies.get("ma_session"),
    inited: false,
    ref: undefined,
    id: undefined,
    name: "",
    acl: undefined,
    menuRef: undefined,
    access: { "": true },
    logins: [],
    classesRools: {},
  };
}

export default state;
